import { Configuration, RedirectRequest } from '@azure/msal-browser';

const CLIENT_ID = process.env.REACT_APP_AZURE_CLIENT_ID || 'cb50af81-8f17-4e74-b328-865b75c730d3';
const TENANT_ID = process.env.REACT_APP_AZURE_TENANT_ID || '90204fe8-7ef2-4572-9674-ca42495f418b';

export const msalConfig: Configuration = {
  auth: {
    clientId:    CLIENT_ID,
    authority:   `https://login.microsoftonline.com/${TENANT_ID}`,
    redirectUri: window.location.origin,
  },
  cache: {
    // localStorage is shared across all windows of the same origin.
    // sessionStorage is per-window — the popup can't see the parent's
    // interaction state, which causes redirect_bridge_empty_response in MSAL v5.
    cacheLocation: 'localStorage',
  },
};

export const loginRequest: RedirectRequest = {
  scopes: ['User.Read'],
  prompt: 'select_account',
};
